import Model, {
  attr,
  hasMany,
  type AsyncHasMany,
} from '@warp-drive/legacy/model';
import type { Type } from '@warp-drive/core/types/symbols';
import type { EnumValue } from '@linc-technologies/linced-common/enums/base-enum';
import type PersonType from '@linc-technologies/linced-common/enums/person-type';
import type Group from 'linced-admin/models/people-schema/group';

// Proto: people_schema.TemplateSet.
export default class Set extends Model {
  declare [Type]: 'people-schema/set';

  @attr('string', { defaultValue: '' })
  declare name: string;

  @attr('string', { defaultValue: '' })
  declare key: string;

  @attr('string', { defaultValue: '' })
  declare description: string;

  @attr('number', { defaultValue: 0 })
  declare personType: EnumValue<typeof PersonType> | 0;

  @hasMany('people-schema/group', { async: true, inverse: 'templateSetIds' })
  declare groups: AsyncHasMany<Group>;

  @attr('number', { defaultValue: 9999 })
  declare sequence: number;
}
